export default "__VITE_ASSET__d79d8265__"